import { createContext, useContext } from 'react';

interface CartConfigContextProps {
  enableCartAU: boolean;
  setEnableCartAU: (enabled: boolean) => void;
  enableCartNZ: boolean;
  setEnableCartNZ: (enabled: boolean) => void;
  isCartEnabled: boolean;
  isLoading: boolean;
}

export const CartConfigContext = createContext<CartConfigContextProps | undefined>(undefined);

export const useCartConfig = () => {
  const context = useContext(CartConfigContext);
  if (!context) {
    throw new Error('useCartConfig must be used within a CartConfigProvider');
  }
  return context;
};
